import React from "react";
import styles from "./Tab.module.css";

const tabName = (name) => {
  return name.replace(/([a-z])([A-Z])/g, "$1 $2"); 
};

const Tab = ({ keys, activeKey, onSelect, classes = "" }) => {
  const onClick = (selectedKey) => {
    onSelect(selectedKey);
  };
  return (
    <div className={styles.tab + " " + classes}>
      {keys.map((key, index) => (
        <span
          key={index}
          className={`${styles.tabComponent} ${
            activeKey === key ? styles.active : ""
          }`}
          onClick={() => onClick(key)}
        >
          {tabName(key)}
        </span>
      ))}
    </div>
  );
};

export default Tab;
